/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AllergenModalUpdateMutationVariables = {|
  id: string,
  name?: ?string,
  color?: ?string,
|};
export type AllergenModalUpdateMutationResponse = {|
  +allergenUpdate: ?{|
    +allergen: ?{|
      +id: string,
      +name: string,
      +color: ?string,
      +image: ?string,
    |}
  |}
|};
export type AllergenModalUpdateMutation = {|
  variables: AllergenModalUpdateMutationVariables,
  response: AllergenModalUpdateMutationResponse,
|};
*/


/*
mutation AllergenModalUpdateMutation(
  $id: ID!
  $name: String
  $color: String
) {
  allergenUpdate(input: {id: $id, name: $name, color: $color}) {
    allergen {
      id
      name
      color
      image
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "color",
    "type": "String"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "color",
            "variableName": "color"
          },
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          },
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "AllergenUpdatePayload",
    "kind": "LinkedField",
    "name": "allergenUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AllergenNode",
        "kind": "LinkedField",
        "name": "allergen",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "image",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AllergenModalUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AllergenModalUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "AllergenModalUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation AllergenModalUpdateMutation(\n  $id: ID!\n  $name: String\n  $color: String\n) {\n  allergenUpdate(input: {id: $id, name: $name, color: $color}) {\n    allergen {\n      id\n      name\n      color\n      image\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e353a8d8c25df6f5c4a866d1b2fc79a9';

module.exports = node;
